<template>
  <div id="app">
    <div class="header">
      <div class="ptb27">月账单统计</div>
      <div>
        <img
          class="loginOutImg"
          :src="loginOutImg"
          alt=""
          @click="handleLoginOut"
        />
      </div>
      <!-- 筛选 -->
      <div class="header-select" @click="handleMerchantSelect">
        <div>
          <img class="merchantIcon" :src="merchantIcon" alt="" />
        </div>
        <div class="header-select-title" v-if="merchantIds.length === 0">
          全部商户
        </div>
        <div class="header-select-title2" v-else>
          已选商户+ {{ merchantIds.length }}
        </div>

        <div>
          <img class="rightIcon pt8" :src="rightIcon" alt="" />
        </div>
      </div>
      <!-- 结算合计 -->
      <div class="settlement-total">
        <div class="settlement-total-date" @click="show = true">
          <div class="cur">{{ timeStr }}</div>
          <div>
            <img class="timeIcon" :src="timeIcon" alt="" />
          </div>
        </div>
        <div class="total-settled-amount" v-if="settlementStatus === 'settled'">
          已结算合计
        </div>
        <div
          class="total-settled-amount"
          v-if="settlementStatus === 'unsettled'"
        >
          未结算合计
        </div>
        <div class="bill-details">
          <div class="bill-details-left">{{ total }}笔</div>
          <div class="bill-details-right cur" @click="ToBillDetails">
            账单明细
          </div>
        </div>
      </div>
    </div>
    <!-- 订单构成 -->
    <div class="orderDetail">订单构成</div>
    <div class="orderCard" v-for="(item, index) in list2" :key="index">
      <div
        class="orderItem"
        v-for="it in item.details"
        :key="it.id"
        @click="handleOrderItem(it)"
      >
        <div class="df">
          <div>
            <img
              class="smallIcon"
              :src="svipIcon"
              alt=""
              v-if="item.productType === 'base'"
            />
            <img
              class="smallIcon"
              :src="vipIcon"
              alt=""
              v-if="item.productType === 'china_base'"
            />
            <img
              class="smallIcon"
              :src="lixianIcon"
              alt=""
              v-if="item.productType === 'offline'"
            />
            <img
              class="smallIcon"
              :src="yinshipinIcon"
              alt=""
              v-if="item.productType === 'video'"
            />
          </div>
          <div>{{ it.productName }}</div>
        </div>
        <div class="df">
          <div>{{ it.count }}笔</div>
          <div>
            <img class="rightIcon pt2 pl8" :src="rightIcon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="list2 && list2.length === 0">
      <van-empty description="暂无数据" />
    </div>
    <!-- 选择日期 -->
    <van-popup
      v-model="show"
      round
      closeable
      position="bottom"
      :style="{ height: '60%' }"
      :close-on-click-overlay="false"
    >
      <div class="p16">
        <div class="date-title">选择日期</div>
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择日期"
          :min-date="minDate"
          :formatter="formatter"
          :show-toolbar="false"
        />
        <div class="date-submit" @click="handleDatetimePickerOk">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { getCommisionSummary } from "@/api/home";
export default {
  data () {
    return {
      show: false,
      minDate: new Date(2020, 0, 1),
      currentDate: new Date(),
      timeStr: "",
      timeStr2: "",
      loginOutImg: require("../assets/login-out.png"),
      merchantIcon: require("../assets/merchant-icon.png"),
      rightIcon: require("../assets/right-icon.png"),
      timeIcon: require("../assets/icon-time.png"),
      svipIcon: require("../assets/icon-svip.png"),
      vipIcon: require("../assets/icon-vip.png"),
      lixianIcon: require("../assets/icon-lixian.png"),
      yinshipinIcon: require("../assets/icon-yinshipin.png"),
      list: [
        {
          id: 0,
          type: 0,
          items: [
            {
              id: 11,
              name: '国际VIP-7天',
              count: 5
            },
            {
              id: 12,
              name: '国际VIP-1个月',
              count: 2
            },
            {
              id: 13,
              name: '国际VIP-6个月',
              count: 3
            },
            {
              id: 14,
              name: '国际VIP-1年',
              count: 5
            }
          ]
        },
        {
          id: 1,
          type: 1,
          items: [
            {
              id: 21,
              name: '基础VIP-7天',
              count: 5
            },
            {
              id: 22,
              name: '基础VIP-1个月',
              count: 2
            },
            {
              id: 23,
              name: '基础VIP-6个月',
              count: 3
            },
            {
              id: 24,
              name: '基础VIP-1年',
              count: 5
            }
          ]
        },
        {
          id: 2,
          type: 2,
          items: [
            {
              id: 31,
              name: '离线翻译',
              count: 20
            }
          ]
        },
        {
          id: 3,
          type: 3,
          items: [
            {
              id: 41,
              name: '音视频翻译-20分钟',
              count: 5
            },
            {
              id: 42,
              name: '音视频翻译-60分钟',
              count: 5
            },
            {
              id: 43,
              name: '音视频翻译-120分钟',
              count: 5
            },
            {
              id: 44,
              name: '音视频翻译-300分钟',
              count: 5
            }
          ]
        }
      ],
      list2: [],
      total: 0,
      settlementStatus: "", // 结算状态 settled:结算完成/unsettled:未结算
      merchantIds: [],
      billQuerys: {
        productIds: [],
        merchantIds: [],
        ids: []
      }
    }
  },
  mounted () {
    this.timeStr = this.timeFormatting(this.currentDate)
    this.timeStr2 = this.timeFormatting2(this.currentDate)
    const homeQuerys = JSON.parse(localStorage.getItem("homeQuerys"))
    if (homeQuerys) {
      this.merchantIds = homeQuerys.merchantIds
    }
    this.getCommisionSummaryNet()
    localStorage.removeItem('billQuerys')
  },
  methods: {
    getCommisionSummaryNet () {
      const params = {
        month: this.timeStr2,
      }
      if (this.merchantIds && this.merchantIds.length != 0) {
        params.merchantIds = this.merchantIds
      }
      getCommisionSummary(params).then(res => {
        // console.log("业务佣金总览---res", res);
        if (res?.data) {
          this.total = res.data.total
          this.settlementStatus = res.data.settlementStatus
          this.list2 = res?.data?.items || []
          localStorage.removeItem("homeQuerys")

        }
      })
    },

    timeFormatting (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return y + '年' + m + '月'
    },
    timeFormatting2 (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return y + '-' + m
    },
    handleOrderItem (val) {
      this.billQuerys.productIds = val.productIds
      this.billQuerys.ids.push(val.id)
      localStorage.setItem("billQuerys", JSON.stringify(this.billQuerys))
      this.$router.push({
        path: "/BillDetails"
      })
    },
    handleMerchantSelect () {
      this.$router.push({
        path: '/SelectMerchant'
      })
    },
    handleLoginOut () {

      Dialog.confirm({
        title: '确认退出登录吗？',
        message: '',
      })
        .then(() => {
          this.$store.dispatch("user/resetToken").then((res) => {
            console.log("res----user/resetToken", res);
          });
          localStorage.removeItem("acount");
          localStorage.removeItem("refreshToken");
          this.$router.push({
            path: '/login'
          })
        })
        .catch(() => {
          console.log('取消退出');
        });
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    handleDatetimePickerOk () {
      this.timeStr = this.timeFormatting(this.currentDate)
      this.timeStr2 = this.timeFormatting2(this.currentDate)
      this.getCommisionSummaryNet()
      this.show = false
    },
    ToBillDetails () {
      this.$router.push({
        path: "/BillDetails"
      })
    }
  }
}
</script>

<style scoped>
#app {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-bottom: 16px;
}
.df {
  display: flex;
  justify-content: center;
}
.header {
  position: relative;
  /* width: 375px; */
  width: 100%;
  height: 280px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  background-image: url("../assets/headerBackground.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;
  box-sizing: border-box;
}
.ptb27 {
  padding: 27px 0px;
}
.loginOutImg {
  position: absolute;
  top: 28px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.merchantIcon {
  width: 20px;
  height: 20px;
  padding-top: 6px;
  padding-right: 16px;
}
.rightIcon {
  width: 16px;
  height: 16px;
}
.timeIcon {
  width: 16px;
  height: 16px;
  padding-left: 6px;
  cursor: pointer;
}
.header-select {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 16px;
  background: #ffffff;
  padding: 0px 16px;
  box-sizing: border-box;
  cursor: pointer;
}
.header-select-title {
  flex: 1;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.header-select-title2 {
  flex: 1;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #f65e3d;
}

.settlement-total {
  width: 100%;
  height: 127px;
  border-radius: 16px;
  background: #ffffff;
  padding: 0px 16px;
  box-sizing: border-box;
  margin: 16px 0px 0px;
}
.orderDetail {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  margin: 16px;
}
.settlement-total-date {
  display: flex;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  padding-top: 12px;
}
.cur {
  cursor: pointer;
}
.total-settled-amount {
  font-family: Source Han Sans;
  font-size: 12px;
  font-weight: 350;
  line-height: 16px;
  text-align: left;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #8d8d8d;
  padding-top: 16px;
  padding-bottom: 8px;
}
.bill-details {
  display: flex;
  justify-content: space-between;
}
.bill-details-left {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #0e273b;
}
.bill-details-right {
  width: 88px;
  height: 28px;
  border-radius: 14px;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #f65e3d;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 350;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #f65e3d;
  margin-top: 7px;
}
.smallIcon {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-right: 8px;
}
.orderCard {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e273b;
  border-radius: 16px;
  opacity: 1;
  background: #ffffff;
  padding: 16px;
  margin: 16px;
}
.orderItem {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: pointer;
}
.df {
  display: flex;
}
.pt8 {
  padding-top: 8px;
}
.pt2 {
  padding-top: 2px;
}
.pl8 {
  padding-left: 8px;
}
.p16 {
  padding: 0px 16px;
}
.date-title {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #0e273b;
  z-index: 1;
  padding: 18px 0px;
}
.date-submit {
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
  background: #f65e3d;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
</style>